import React, { useState, useEffect, useCallback } from "react";
import { getJudgeName } from "../../utils";

const Phase3 = (props) => {
  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetPhase = props.handleSetPhase
  const handleUpdatePhotoCard = props.handleUpdatePhotoCard
  const handleSetStale = props.handleSetStale

  const [error, setError] = useState('')

  const placeholders = [
    "https://johnsonfamreunion.s3.us-west-2.amazonaws.com/Memes/stock/meme3.jpeg",
    "https://johnsonfamreunion.s3.us-west-2.amazonaws.com/Memes/stock/meme2.jpeg",
    "https://johnsonfamreunion.s3.us-west-2.amazonaws.com/Memes/stock/meme4.jpeg",
  ]
  const randomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  const placeholder = placeholders[randomNumber(0, placeholders.length - 1)]

  const handlePhotoCardSelected = (photoCard) => {
    if (getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants) !==
      localStorage.getItem('participantName')) {
      setError(`Only the judge - 
        ${getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants)} - 
        can select a photo card for this round.`)
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
      return
    }

    handleGameStateChanged({newPhoto: photoCard.$id, newPhase: 4})
    handleUpdatePhotoCard(photoCard, true)
  }

  const loadPhotoCardsList = useCallback(() => {
    return (
      <div className="grid">
        {props.photoCards?.map((photoCard, _) => {
          if (photoCard.HasBeenUsed === true) return null
          return (
            <div
              key={photoCard.$id}
              className="w-[90%] mx-[5%] mt-5 border border-black rounded-xl grid place-items-center cursor-pointer "
              onClick={() => {
                handlePhotoCardSelected(photoCard)
              }}
            >
              <img className="w-[100%] rounded-xl grayscale hover:shadow-2xl hover:grayscale-0 transition duration-500 ease-in-out" src={placeholder} />
            </div>
          )
        })
        }
      </div>
    )
  }, [props.photoCards, handlePhotoCardSelected, placeholder]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSetStale({stale: true})
    }, 3000);
  }, [])

  return (
    <>
      <div className="mt-[8%] mx-5 border border-black rounded-xl grid place-items-center">
        <div className="p-[2%]">
          <h1 className="text-4xl font-bold text-center text-black">{getJudgeName(props.judge["Name"], props.gameState, props.gameParticipants)}</h1>
        </div>

        <div className="my-[3%] px-8 items-center">
          <h3 className="text-gray-950">Choose a photo card by clicking on one of the below placeholders</h3>
        </div>
      </div>

      {!!error &&
        <div className="mt-4">
          <div className="border border-black rounded-lg bg-red-500 m-4 p-4 text-white text-xl">{error}</div>
        </div>
      }

      <div className="mt-[5%] place-items-center">
        {loadPhotoCardsList()}
      </div>
    </>

  )
}

export default Phase3;
